import React from 'react'

function CopyrightCaption() {
  const currentYear = new Date().getFullYear(); 

  return (
    <div>
      <span className="font-semibold text-secondary">Copyright {currentYear} | All Rights Reserved</span> 
    </div>
  )
}

export default CopyrightCaption
